import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-right",
  "use": "icon-right-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-right\">\n<g id=\"icon-right_Group 427323849\">\n<path id=\"icon-right_Vector 24\" d=\"M6.65674 4L10.8994 8.24264L6.65674 12.4853\" stroke=\"#4C4C4C\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol